import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/deals/[slug]/DealsPageNew.js");
;
import(/* webpackMode: "eager" */ "/app/app/deals/[slug]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image/Image.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Meta.js");
;
import(/* webpackMode: "eager" */ "/app/src/services/RouteService.js");
